import { LaydownLogTableConfig } from '../../../../../../models/assets-data/laydown/LaydownLogTableConfig.interface';

/**
 * Default laydown log table configuration used as a fallback if fetching the laydown-log-table-config.json assets file fails.
 * 
 * - Defines table structure, input fields, validation rules, and display settings.
 * - Ensures key fields like Job Number, Contact, Space, and Storage Facility are properly configured.
 * - Supports different input types (text, number, date, select).
 * - Some fields are disabled to prevent modification (e.g., Date In, Logged By).
 * 
 * This ensures the laydown log table remains operational even without dynamic configuration retrieval.
 */
export const DEFAULT_ASSETS_LAYDOWN_LOG_TABLE: LaydownLogTableConfig = {
  laydownLogTable: {
    tableName: "Laydown Log",
    inputs: [
      {
        name: "jobNumber",
        label: "Job Number",
        formFieldType: "input",
        required: true
      },
      {
        name: "contact",
        label: "Contact",
        formFieldType: "email",
        optionListId: "employeeEmails",
        required: true
      },
      {
        name: "space",
        label: "Space",
        formFieldType: "input",
        options: [
          { value: "A", label: "A" },
          { value: "B", label: "B" }
        ],

           disabled: true,
      required: true
      },
      {
        name: "dateIn",
        label: "Date In",
        formFieldType: "date",
        placeholder: "MM/DD/YY",
        disabled: true,
        required: true
      },
      {
        name: "estDateOut",
        label: "Est. Date Out",
        formFieldType: "date",
        placeholder: "MM/DD/YY"
      },
      {
        name: "dateOut",
        label: "Date Out",
        formFieldType: "date",
        placeholder: "MM/DD/YY"
      },
      {
        name: "loggedBy",
        label: "Logged By",
        formFieldType: "input",
        disabled: true,
        required: true
      },
      {
        name: "storageFacility",
        label: "Storage Facility",
        formFieldType: "select",
           disabled: true,
        required: true
      }
    ]
  }
  };
  